import React, { Component } from 'react';
import NoData from './NoData';
import Input from './Input';
import Loading from './loading';

class CardList extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    //  this.scrollToBottom();
  }
  componentDidUpdate() {
    //  this.scrollToBottom();
  }

  scrollToBottom() {
    const scrollHeight = this.el.scrollHeight;
    const height = this.el.clientHeight;
    const maxScrollTop = scrollHeight - height;
    this.el.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
  }

  render() {
    const {
      isCrerate,
      handleClick,
      data,
      value,
      handleChange,
      keyPress,
      handleDataList,
      handleDelete,
      handleShowModal,
      handleGetListId,
      listId,
      language,
      loading,
      lists,
      onEscape,
      disableListHover
    } = this.props;
    return (
      <div className="card-container">
        <div className="header-one">
          <div className="item-right">
            <h5>{this.props.title}</h5>
          </div>
          <div className="right-item">
            <div>
              <span
                className={`fa-stack fa-1x ${isCrerate && listId ? '' : 'list-icon-create'}`}
                onClick={handleClick}
              >
                <i className="fas fa-circle fa-stack-1x " />
                <i className="fas fa-plus fa-stack-1x fa-inverse" />
              </span>
              <span className="create-text"> {this.props.create} </span>
            </div>
          </div>
        </div>
        <div className="header-two">
          <div className="header-two-item-right">
            <h5>{this.props.name}</h5>
          </div>
          <div className="header-two-right-item">
            <div>
              <h5>{this.props.action}</h5>
            </div>
          </div>
        </div>
        <div
          className={isCrerate || lists.datos.length > 0 ? 'card-content-input' : 'card-content'}
          ref={el => {
            this.el = el;
          }}
        >
          {isCrerate || lists.datos.length > 0 ? (
            <Input
              data={data}
              isCrerate={isCrerate}
              lists={lists}
              value={value}
              handleChange={handleChange}
              keyPress={keyPress}
              handleDataList={handleDataList}
              handleDelete={handleDelete}
              handleShowModal={handleShowModal}
              handleGetListId={handleGetListId}
              listId={listId} // display card list input denpends on condition
              language={language}
              loading={loading}
              onEscape={onEscape}
              disableListHover={disableListHover}
            />
          ) : (
            <NoData legend={this.props.legend} />
          )}
          {loading | (lists.loading == true) ? <Loading /> : ''}
        </div>
      </div>
    );
  }
}
export default CardList;



// WEBPACK FOOTER //
// ./source/client/components/dynamic_list/CardList.jsx